import { gql } from '@apollo/client'

export const GET_CONFIG = gql`query { config { projectName, menu, theme } }`
